"use client"

import { Button, Modal } from "antd"
import Image from "next/image"
import { useEffect, useState } from "react"
import { ADMIN_API_CONFIG } from "../../../../../constants/api-configs"
import { DefaultImage, Media, MediaUpload } from "../../../../../lib/external-components"

type ImageValue = string | { url: string; alternativeText?: string } | undefined

interface SlideItemProps {
  value?: ImageValue
  onChange?: (value: string) => void
  hideUrl?: boolean
}

// Helper function to extract URL from value
const getUrlFromValue = (value: ImageValue): string => {
  if (!value) return ""
  if (typeof value === "string") return value
  if (typeof value === "object" && "url" in value) return value.url
  return ""
}

export const ImageUploadField = ({ value, onChange, hideUrl }: SlideItemProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)
  const [url, setUrl] = useState(getUrlFromValue(value))

  const openModal = () => {
    setIsModalOpen(true)
  }

  // Update URL when value prop changes
  useEffect(() => {
    setUrl(getUrlFromValue(value))
  }, [value])

  const handleSelectMedia = (media: { url: string }) => {
    setUrl(media.url)
    onChange?.(media.url)
    setIsModalOpen(false)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div className="flex flex-col gap-2">
      {!hideUrl && (
        <input type="text" value={url} onChange={e => onChange?.(e.target.value)} placeholder="Image URL" readOnly />
      )}
      <div className="relative cursor-pointer group" onClick={() => openModal()}>
        <Image
          src={url ? `${ADMIN_API_CONFIG.API_URL}${url}` : DefaultImage}
          alt="Image"
          width={200}
          height={150}
          className="rounded-lg max-h-32 cursor-pointer transition duration-300 ease-in-out group-hover:blur-sm overflow-hidden object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 ease-in-out">
          <span className="text-white text-sm font-semibold drop-shadow-md">Change media</span>
        </div>
      </div>

      <Button
        onClick={() => openModal()}
        type="default"
        variant="outlined"
        className="bg-blue text-white p-2 border-[1px] border-blue rounded-md hover:bg-blue-800 hover:text-white duration-300"
      >
        {isChooseMedia ? "Change Media" : "Select Media"}
      </Button>

      <Modal
        open={isModalOpen}
        title={<span className="ml-4">Select Media</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div className="ml-4 mt-5">
          <Button
            onClick={() => setIsChooseMedia(true)}
            className="mr-2"
            style={{
              backgroundColor: isChooseMedia ? "blue" : "initial",
              color: isChooseMedia ? "white" : "initial",
            }}
          >
            {isChooseMedia ? "Change Media" : "Select Media"}
          </Button>
          <Button
            onClick={() => setIsChooseMedia(false)}
            style={{
              backgroundColor: !isChooseMedia ? "blue" : "initial",
              color: !isChooseMedia ? "white" : "initial",
            }}
          >
            Upload Media
          </Button>
        </div>
        <div>
          {isChooseMedia ? (
            <Media isOpenModal={true} onSelectMedia={handleSelectMedia} />
          ) : (
            <MediaUpload isOpenModal={true} setChooseMedia={setIsChooseMedia} />
          )}
        </div>
      </Modal>
    </div>
  )
}
